module.exports = fox._r("images/headerBg.jpg", __webpack_public_path__ + "images/headerBg.jpg");


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/node_modules/fox-file-loader!/var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/node_modules/file-loader?name=[path][name].[ext]!./images/headerBg.jpg
// module id = 973
// module chunks = 4